import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ICreateEntitiesRequest, specizliedRolesData } from '../../../..';
import { IPaginationParameters, IPaginationResponse } from '../../../../core';
import { IPermissionGroup, permissionGroupsTestData } from '../../../permission-management';
import {
  ISpecializedRoleResponse,
  ICreateSpecializedRolesRequest,
  ISpecializedRoleCreateResponse,
  IUpdateSpecializedRolesRequest
} from '../dtos';
import { ISpecializedRolesApiClient } from './i-specialzied-roles.api.client';

@Injectable({
  providedIn: 'root'
})
export class SpecializedRolesInMemoryApiClientProvider implements ISpecializedRolesApiClient {
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<ISpecializedRoleResponse>> {
    return of(specizliedRolesData.specilziedRoles);
  }

  getById(id: string): Observable<ISpecializedRoleResponse> {
    return of(specizliedRolesData.specialziedRole);
  }

  create(request: ICreateSpecializedRolesRequest): Observable<ISpecializedRoleCreateResponse> {
    return of(specizliedRolesData.specialziedRoleCreateResponse);
  }

  update(id: string, request: IUpdateSpecializedRolesRequest): Observable<void> {
    return of();
  }

  assignPermissions(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return of();
  }

  revokePermissions(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return of();
  }

  getPermissions(id: string): Observable<IPermissionGroup[]> {
    return of(permissionGroupsTestData);
  }
}
